import { Injectable } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { CompanyUserService } from '@treasury/domain/company/user';
import { RowActionCommand, RowActionCommandResult } from '../base.cmd';
import { CompanyUserActionType } from './user-actions.types';

@Injectable()
export class BoViewUserCommand implements RowActionCommand<number, CompanyUserActionType> {
    constructor(
        private readonly navigationService: NavigationService,
        private readonly companyUserService: CompanyUserService
    ) {}

    public command(companyId: number): RowActionCommandResult<number, CompanyUserActionType> {
        return {
            type: CompanyUserActionType.View,
            title: 'Manage User',
            action: (userId: number) => this.execute(userId, companyId),
        };
    }

    private async execute(userId: number, companyId: number) {
        await this.companyUserService.saveUserToRecentlyViewedUser(userId, companyId);
        this.navigationService.navigate(`/company/${companyId}/users/${userId}`);
    }
}
